import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import Preloader from "@/components/site/Preloader";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import QuickChat from "@/components/site/QuickChat";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Catalogue from "@/pages/Catalogue";
import { Toaster } from "@/components/ui/sonner";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.section) return; // handled by page
    const t = setTimeout(() => {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.state]);
  return null;
}

function App() {
  useLenis();

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Preloader />
        <ScrollManager />
        <AnnouncementBar />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/catalogue" element={<Catalogue />} />
          </Routes>
        </main>
        <Footer />
        <QuickChat />
        <Toaster position="bottom-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
